import { useState } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";

function GlobalSocietyCard({ globalSociety }) {
  const [selectedCountry, setSelectedCountry] = useState(null);

  const handleCountryClick = (country) => {
    setSelectedCountry(country);
    console.log("Selected country:", country);
  };

  const handleJoinCommunity = () => {
    console.log("Join SBI Community");
  };

  const handleMedicalSocieties = () => {
    console.log("View medical societies");
  };

  return (
    <Card
      sx={(theme) => ({
        height: "100%",
        borderRadius: theme.borders.borderRadius.lg,
        boxShadow: theme.boxShadows.md,
        backgroundColor: theme.functions.rgba(theme.palette.background.default, 0.8),
      })}
    >
      <MDBox p={3}>
        <MDBox display="flex" alignItems="center" mb={3}>
          <Icon sx={{ fontSize: "1.5rem", mr: 1, color: "text" }}>public</Icon>
          <MDTypography variant="h5" fontWeight="bold" color="dark">
            Global Society
          </MDTypography>
        </MDBox>

        {/* Your Local SBI */}
        <MDBox mb={3}>
          <MDTypography variant="body2" fontWeight="medium" color="text" mb={1.5}>
            Your Local SBI
          </MDTypography>
          <MDBox display="flex" flexWrap="wrap" gap={1}>
            {globalSociety.countries.map((country, index) => (
              <Chip
                key={index}
                label={country}
                onClick={() => handleCountryClick(country)}
                sx={{
                  backgroundColor: selectedCountry === country ? "#1a4d4d" : "#F5F5F5",
                  color: selectedCountry === country ? "white" : "#1a4d4d",
                  fontWeight: selectedCountry === country ? "bold" : "medium",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#1a4d4d",
                    color: "white",
                  },
                }}
              />
            ))}
          </MDBox>
        </MDBox>

        {/* Join Community CTA */}
        <MDBox mb={3}>
          <MDButton
            variant="gradient"
            color="info"
            fullWidth
            onClick={handleJoinCommunity}
            sx={{ mb: 2 }}
          >
            Join SBI Community
          </MDButton>
        </MDBox>

        <Divider sx={{ my: 3 }} />

        {/* Partner Badges */}
        <MDBox>
          <MDTypography variant="body2" fontWeight="medium" color="text" mb={2}>
            Technology Collaborators
          </MDTypography>
          <MDBox display="flex" flexWrap="wrap" gap={2} mb={3}>
            {globalSociety.technologyPartners.map((partner, index) => (
              <MDBox
                key={index}
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={80}
                height={40}
                borderRadius="sm"
                sx={{
                  backgroundColor: "#F5F5F5",
                  border: "1px solid #E0E0E0",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#E0E0E0",
                    transform: "scale(1.05)",
                  },
                }}
              >
                <MDTypography variant="caption" color="text" fontWeight="medium">
                  {partner.name}
                </MDTypography>
              </MDBox>
            ))}
          </MDBox>

          <MDButton
            variant="text"
            color="info"
            fullWidth
            onClick={handleMedicalSocieties}
            startIcon={<Icon>groups</Icon>}
          >
            Medical Societies
          </MDButton>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default GlobalSocietyCard;
